import { PORTAL_HEADER } from './storage';
import { portalFetchInit } from './portalApiAuth';
import { franchiseAuthHeaders } from '../shared/franchiseFlowAuth';

/** HQ portal API calls — HttpOnly cookie auth; kiosk uses same cookie + GPS headers. */
export function buildHqSessionHeaders(portalId, extra = {}) {
  return franchiseAuthHeaders({
    'Content-Type': 'application/json',
    [PORTAL_HEADER]: portalId,
    ...extra,
  });
}
export function hqSessionFetchInit(portalId, extra = {}) {
  const { headers: extraHeaders, ...rest } = extra;
  return {
    credentials: 'include',
    ...rest,
    headers: buildHqSessionHeaders(portalId, extraHeaders || {}),
  };
}

export function kioskAdminFetch(portalId, tokenStorageKey, url, init = {}) {
  return fetch(url, portalFetchInit(portalId, tokenStorageKey, init));
}
